<template>
    <p v-if="calculationData">
        <strong class="ml-1">Fordonsinformation</strong>        
        <table class="table table-striped table-sm">
            <tbody>
                <tr>
                    <td style="width:20%">Modell</td>
                    <td>{{calculationData.BenefitVehicle.Model}}</td>
                </tr>
                <tr>
                    <td>Registreringsnummer</td>
                    <td>{{calculationData.BenefitVehicle.RegistrationNumber}}</td>
                </tr>
                <tr>
                    <td>Förmånsvärde</td>
                    <td>{{calculationData.BenefitVehicle.BenefitValue | currency}} kr</td>
                </tr>                                   
            </tbody>
        </table>
        <strong class="ml-1">Utgifter</strong> (Ingår ej i uträkning)
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th style="width:10%">Datum</th>
                    <th>Projekt</th>
                    <th>Kategori</th>
                    <th style="width:10%" class="text-center">Kvitto</th>
                    <th style="width:10%" class="text-right">Kostnad</th>                
                </tr>
            </thead>   
            <tbody>
                <tr v-for="entry in calculationData.Expenses" :key="entry.id">
                    <td style="width:15%">{{entry.Spent | moment("YYYY-MM-DD")}}</td>
                    <td>{{entry.Project}}</td>
                    <td>{{entry.Category}}</td>
                    <td style="width:10%" class="text-center"><a href="#" v-on:click="downloadReceipt(entry)" class="cui-paperclip icons"></a></td>
                    <td style="width:10%" class="text-right">{{entry.Cost | currency}}</td>                 
                </tr>       
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="4">Summa</th>                
                    <td class="text-right"><strong>{{calculationData.Expenses.reduce((s, f) => s+f.Cost, 0) | currency}}</strong></td>
                </tr>
            </tfoot>
        </table>
        <strong class="ml-1">Summering</strong>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th style="width:25%">Typ</th>
                    <th>Kommentar</th>              
                    <th style="width:10%" class="text-right">Kostnad</th>                
                </tr>
            </thead>   
            <tbody>
                <tr>
                    <td>Leasingavgift</td>
                    <td></td>
                    <td class="text-right">{{leasingCosts | currency}}</td>
                </tr>
                <tr>
                    <td>Moms leasingavgift</td>
                    <td>12,5% av leasingavgift</td>
                    <td class="text-right">{{leasingVat  | currency}}</td>
                </tr>                
                <tr>
                    <td>Övrigt</td>
                    <td>Försäkring, Serviceavtal, aviavgifter mfl</td>
                    <td class="text-right">{{otherCosts | currency}}</td>
                </tr>
               <tr>
                    <td>Arb. avg. förmånsvärde </td>
                    <td></td>
                    <td class="text-right">{{calculationData.PayrollTaxForBenefitValue | currency}}</td>
                </tr> 
                <tr>
                    <td>Reducering arb. avg </td>
                    <td></td>
                    <td class="text-right">{{reducedPayrollTax | currency}}</td>
                </tr>                                
                <tr v-if="calculationData.ReducedGrossSalary > 0">
                    <td>Reducerad bruttolön</td>
                    <td></td>
                    <td class="text-right">- {{calculationData.ReducedGrossSalary | currency}}</td>
                </tr>                                  
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="2">Summa bruttolöneavdrag</th>                
                    <td class="text-right"><strong>{{calculationData.GrossSalaryDiscount | currency}}</strong></td>
                </tr>
            </tfoot>
        </table>               
    </p>
    
</template>

<script>
import { expensesService } from "../../../../shared/services";
export default {
    computed: {
        leasingCosts() {
            return this.calculationData.LeasingExpenseItems.reduce((s, f) => s+f.Cost, 0);
        },
        otherCosts() {
            return this.calculationData.OtherExpenseItems.reduce((s, f) => s+f.Cost, 0);
        },
        leasingVat() {
            return this.calculationData.LeasingExpenseItems.reduce((s, f) => s+f.Cost*f.Vat, 0)
        },
        reducedPayrollTax() {
            var costs = this.leasingCosts + this.otherCosts + this.leasingVat + this.calculationData.PayrollTaxForBenefitValue;
            var sum = costs/(1+this.calculationData.PayrollTax)
            return costs-sum;

        }
    },
    props: {
        calculationData: null
    },
    methods: {
        downloadReceipt(entry) {
            var expense  = {
                id: entry.Id,
                receiptFileName: entry.ReceiptFileName
            }
            if(!expense.receiptFileName) {
                expense.receiptFileName = entry.Receipt.substring(entry.Receipt.lastIndexOf('/')+1);
            }
            expensesService.downloadReceipt(expense);
        }
    }
}
</script>

<style>

</style>
